<div id="table-filter-container">
  <!-- if the column is not filterable then just show it as a disabled text box. -->
  <div>
    @if (col.filterable === false) {
      <input pInputText type="text" [ngModel]="col.defaultValue" disabled />
    } @else {
      <!-- filterable column that has a type of drop down. -->
      <div>
        @if (col.type === 'dropdown') {
          <p-select
            appendTo="body"
            [style]="{ width: '100%' }"
            [options]="col.options"
            [(ngModel)]="col.value"
            (onChange)="
              this.filterEvent.emit({
                value: $event.value,
                field: col.field,
                matchMode: col.matchMode ? col.matchMode : 'equals',
              })
            "
          />
        }
      </div>
      <!-- Calendar filters use the Optimus datepicker directly. -->
      @if (col.type === 'calendar' && !col.formControl) {
        <p-datepicker
          #picker
          appendTo="body"
          dateFormat="mm/dd/yy"
          placeholder="mm/dd/yyyy"
          [showIcon]="true"
          [ngModel]="col.value"
          (onSelect)="emitCalendarFilter($event, col)"
          (onInput)="calendarInputChanged = true"
          (onBlur)="emitCalendarInputFilter(picker.value, col)"
        />
      }
      @if (col.type === 'calendar' && col.formControl) {
        <p-datepicker
          #formPicker
          [formControl]="col.formControl"
          appendTo="body"
          dateFormat="mm/dd/yy"
          placeholder="mm/dd/yyyy"
          [showIcon]="true"
          [showButtonBar]="true"
          (onSelect)="emitCalendarFilter($event, col)"
          (onClearClick)="emitCalendarFilter(null, col)"
          (onInput)="calendarInputChanged = true"
          (onBlur)="emitCalendarInputFilter(formPicker.value, col)"
        />
      }
      <!-- if the column supports formControl validations -->
      @if (
        col.formControl &&
        !col.maxLength &&
        (col.type === null || col.type === undefined || col.type === 'input')
      ) {
        <div>
          <input
            pInputText
            type="text"
            [class]="getStyleClass(col)"
            (input)="emitInputFilter($event, col)"
            [formControl]="col.formControl"
            [ngModel]="col.value"
          />
        </div>
      }
      @if (
        col.formControl &&
        col.maxLength &&
        (col.type === null || col.type === undefined || col.type === 'input')
      ) {
        <div>
          <input
            pInputText
            type="text"
            [class]="getStyleClass(col)"
            (input)="emitInputFilter($event, col)"
            [formControl]="col.formControl"
            [maxLength]="col.maxLength"
            [ngModel]="col.value"
          />
        </div>
      }
      <!-- if the column does not support formControl validations -->
      @if (
        !col.formControl &&
        !col.maxLength &&
        (col.type === null || col.type === undefined || col.type === 'input')
      ) {
        <div>
          <input
            pInputText
            type="text"
            [ngModel]="col.value"
            (input)="emitInputFilter($event, col)"
          />
        </div>
      }
      @if (
        !col.formControl &&
        col.maxLength &&
        (col.type === null || col.type === undefined || col.type === 'input')
      ) {
        <div>
          <input
            pInputText
            type="text"
            [ngModel]="col.value"
            (input)="emitInputFilter($event, col)"
            [maxLength]="col.maxLength"
          />
        </div>
      }
    }
  </div>
</div>
